import { HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { ApiService } from './api.service';
import StringHelper from '../string.helper';

@Injectable({
  providedIn: 'root',
})
export class FileService extends ApiService {
  upload(file: File, forObject: string, taskId: string = null, objectId: string = null) {
    const formData: FormData = new FormData();

    formData.append('file', file, file.name);
    formData.append('forObject', forObject);

    if (objectId !== null) {
      formData.append('objectId', objectId);
    }

    if (taskId !== null) {
      formData.append('taskId', taskId);
    }

    const req = new HttpRequest('POST', this.getApiUrl('files'), formData, {
      reportProgress: true,
    });

    return this.http.request(req);
  }

  uploadFromEditor(file: File, forObject: string, taskId: string = null, objectId: string = null) {
    const formData: FormData = new FormData();

    formData.append('file', file, file.name);
    formData.append('forObject', forObject);

    if (objectId !== null) {
      formData.append('objectId', objectId);
    }

    if (taskId !== null) {
      formData.append('taskId', taskId);
    }

    const req = new HttpRequest('POST', this.getApiUrl('files/create-editor-image'), formData, {
      reportProgress: true,
    });

    return this.http.request(req);
  }

  uploadAvatar(file: Blob) {
    const name: string = StringHelper.randomString() + '.png';
    const body: FormData = new FormData();

    body.append('file', file, name);

    return this.http.post(this.getApiUrl('files/upload-avatar'), body);
  }

  getBlobFromUrl(url: string): Observable<any> {
    return this.http.get(url, {
      responseType: 'blob',
    });
  }

  delete(fileId: string): Observable<void> {
    return this.http.delete<void>(this.getApiUrl(`files/${fileId}`));
  }
}
